module.exports = "/fast-coin/img/coin/anim/in/coin_in_023.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_023.png
// module id = 2293
// module chunks = 5